import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {

  private titleText = '';
  private OriginalTitle = Constants.APP_TITLE;

  constructor(private bodyTitle: Title) { }

  public get title(): string { return this.titleText; }

  public set title(title: string) {
    this.titleText = title && title.trim() ? title.trim() : '';
    if (title) {
      title = `${title.trim()} | ${Constants.APP_TITLE}`;
    } else {
      title = this.OriginalTitle;
    }
    this.bodyTitle.setTitle(title);
  }
}
